import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Website',
  subtitle: 'Design',
  tagline: 'Beautiful, Conversion-Focused Designs',
  icon: '🎨',
  heroDesc: 'We design stunning, user-centric websites that not only look exceptional but are strategically built to convert visitors into customers — blending creativity with business intelligence.',
  mainStat: '300+',
  mainStatLabel: 'Websites designed across industries in India',
  subStats: [{ value: '4.9★', label: 'Average Client Rating' }, { value: '100%', label: 'Mobile Responsive' }],
  features: [
    { icon: '🎨', title: 'Custom UI Design', desc: 'Unique, brand-aligned designs built from scratch — no generic templates.' },
    { icon: '📱', title: 'Mobile-First Design', desc: 'Every design is optimized for perfect display on all screen sizes and devices.' },
    { icon: '⚡', title: 'Fast Loading Design', desc: 'Lightweight design assets optimized for sub-2-second load times.' },
    { icon: '🔄', title: 'UI/UX Strategy', desc: 'User journey mapping and wireframing for intuitive, conversion-focused experiences.' },
    { icon: '♿', title: 'Accessible Design', desc: 'Designs that meet accessibility standards to reach the widest possible audience.' },
    { icon: '🔍', title: 'SEO-Ready Structure', desc: 'Design architecture built with SEO best practices for strong organic rankings.' },
  ],
  benefits: [
    { title: 'First Impressions That Convert', desc: 'A professionally designed website builds instant credibility and encourages visitors to take action.' },
    { title: 'Brand Consistency', desc: 'Consistent colors, typography, and visual language reinforce your brand identity at every touchpoint.' },
    { title: 'Better User Experience', desc: 'Intuitive navigation and clear CTAs guide visitors toward conversions effortlessly.' },
    { title: 'Competitive Advantage', desc: 'A stunning website sets you apart from competitors with outdated or generic online presences.' },
  ],
  process: [
    { title: 'Discovery & Briefing', desc: 'Deep-dive into your brand, goals, target audience, and competitor landscape.' },
    { title: 'Wireframe & Structure', desc: 'Low-fidelity wireframes to map user journeys and page structures before visual design.' },
    { title: 'Visual Design', desc: 'High-fidelity mockups with full color, typography, and imagery for your approval.' },
    { title: 'Revisions & Approval', desc: 'Up to 3 revision rounds to ensure the design perfectly matches your vision.' },
    { title: 'Handoff & Development', desc: 'Pixel-perfect design files handed off for development or handed to our dev team.' },
  ],
  whyChoose: [
    { icon: '🎯', title: 'Conversion-Focused', desc: 'Every design decision is made with one goal: turning visitors into leads and customers.' },
    { icon: '🏆', title: '300+ Projects Delivered', desc: 'A proven track record across industries from healthcare to real estate to e-commerce.' },
    { icon: '🤝', title: 'Collaborative Process', desc: 'You\'re involved at every stage — we design with you, not just for you.' },
    { icon: '⚡', title: 'Fast Turnaround', desc: 'First design mockups delivered within 5–7 business days of project kickoff.' },
  ],
  reviews: [
    { name: 'Ritu Agarwal', role: 'Interior Designer', text: 'The portfolio website DMS designed for me is absolutely stunning. Clients comment on it every day!' },
    { name: 'Karan Mehta', role: 'Tech Startup', text: 'Our conversion rate jumped by 45% after the website redesign. Best investment we made.' },
    { name: 'Anita Desai', role: 'Bakery Owner', text: 'Couldn\'t believe how beautifully they captured my brand\'s personality in the design.' },
  ],
  faq: [
    { q: 'How many design revisions are included?', a: 'Our standard package includes up to 3 revision rounds. Additional revisions can be added if needed.' },
    { q: 'Do you design landing pages too?', a: 'Absolutely! We design high-converting landing pages for Google Ads, Meta Ads, and product launches.' },
    { q: 'Will I own the design files?', a: 'Yes, upon project completion, all design files (Figma, Adobe XD, or PSD) are transferred to you.' },
  ],
};

export default function WebsiteDesign() {
  return <ServiceTemplate data={data} />;
}
